import { Type } from "@sinclair/typebox";
import { queryOptions, useQuery } from "@tanstack/react-query";
import { api } from "../../lib/api.js";
export const listFreemiumPlanMatchesSchema = Type.Object({
    userId: Type.String(),
    count: Type.Optional(Type.Number()),
    detailed: Type.Optional(Type.Boolean()),
});
export const listFreemiumPlanMatches = ({ userId, count, detailed, }) => {
    return api
        .get(`clients/${userId}/freemiumPlanMatch`, {
        searchParams: {
            ...(count !== undefined && { count }),
            ...(detailed !== undefined && { detailed }),
        },
    })
        .json()
        .then((data) => data.plans);
};
export const listFreemiumPlanMatchesQueryOptions = (filter, client) => {
    return queryOptions({
        queryKey: ["freemium_plan_matches", filter, client],
        queryFn: () => listFreemiumPlanMatches(filter),
    });
};
export const useFreemiumPlanMatches = ({ queryConfig, filter, client, }) => {
    return useQuery({
        ...listFreemiumPlanMatchesQueryOptions(filter, client),
        ...queryConfig,
    });
};
//# sourceMappingURL=listFreemiumPlanMatches.js.map